module.exports = __webpack_public_path__ + "static/media/choir-icon-blue.8aeabfde.svg";